import type { CSSProperties, HTMLAttributes, ReactNode } from "react";
import { shadow } from "../design-system";

type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

/**
 * Surface de carte : fond blanc, arrondi `card`, élévation sh-1.
 *
 * Le `StyleSheet.create` de la version native n'existait que pour porter le
 * `Platform.select` iOS/Android de l'ombre. Le web n'a qu'un modèle
 * (`box-shadow`) : le token s'applique directement.
 */
export function Card({ children, className, style, ...props }: CardProps) {
  return (
    <div
      {...props}
      className={["bg-white rounded-card", className].filter(Boolean).join(" ")}
      style={{ boxShadow: shadow.sh1, ...style }}
    >
      {children}
    </div>
  );
}
